import React, {useMemo} from 'react'

const MIN_SUCHLAENGE = 3;

/**
 * Eingabefeld "Spieler finden" mit Vorschlagsliste. Der gewählte Spieler wird in allen Bereichen hervorgehoben.
 */
export default function SpielerSuche({tournamentWrapper, eingabe, onEingabe, markierterSpieler, anzahlTreffer}) {

    const spielernamen = useMemo(() => ermittleSpielernamen(tournamentWrapper), [tournamentWrapper]);

    const getStatusText = () => {
        if (eingabe.trim() === "") {
            return undefined;
        }
        if (markierterSpieler === undefined) {
            return eingabe.trim().length < MIN_SUCHLAENGE ? "Suche ab " + MIN_SUCHLAENGE + " Zeichen" : "Kein eindeutiger Spieler";
        }
        if (anzahlTreffer === 0) {
            return "Hier nicht vorhanden";
        }
        return anzahlTreffer === 1 ? "1 Treffer" : anzahlTreffer + " Treffer";
    }

    const statusText = getStatusText();

    return <div className="dhpt-suche">
        <i className="pi pi-search dhpt-suche-icon" aria-hidden="true"/>
        <input id="dhpt-spieler-suche" type="search" list="dhpt-spieler-liste" className="dhpt-suche-feld"
               placeholder="Spieler finden …" aria-label="Spieler finden und hervorheben" autoComplete="off"
               value={eingabe} onChange={(e) => onEingabe(e.target.value)}/>
        <datalist id="dhpt-spieler-liste">
            {spielernamen.map(name => <option key={name} value={name}/>)}
        </datalist>
        {statusText && <span className="dhpt-suche-status" aria-live="polite">{statusText}</span>}
        {eingabe !== "" &&
            <button type="button" className="dhpt-suche-leeren" aria-label="Suche leeren" onClick={() => onEingabe("")}>
                <i className="pi pi-times" aria-hidden="true"/>
            </button>
        }
    </div>
}

export function ermittleSpielernamen(tournamentWrapper) {
    const namen = new Set();
    for (const turnier of [tournamentWrapper.turnierMain, tournamentWrapper.turnierGruppe, tournamentWrapper.turnierKO,
        tournamentWrapper.turnierSilber, tournamentWrapper.turnierBronze]) {
        if (turnier === null || turnier === undefined || !turnier.tournamentPlayerEntities) {
            continue;
        }
        for (const spieler of turnier.tournamentPlayerEntities) {
            if (spieler.name) {
                namen.add(spieler.name.trim());
            }
        }
    }
    return [...namen].sort((a, b) => a.localeCompare(b, "de"));
}

/**
 * Ermittelt aus der Eingabe den gemeinten Spieler: exakter Name, sonst der einzige Name, der die Eingabe enthält.
 */
export function ermittleMarkiertenSpieler(eingabe, spielernamen) {
    const suche = eingabe.trim().toLowerCase();
    if (suche === "") {
        return undefined;
    }
    // ein exakter Name (z.B. aus der Vorschlagsliste) gilt immer, auch wenn er kürzer ist
    const exakt = spielernamen.find(name => name.toLowerCase() === suche);
    if (exakt !== undefined) {
        return exakt;
    }
    // Teilsuche erst ab 3 Zeichen, vorher sind die Treffer nicht aussagekräftig
    if (suche.length < MIN_SUCHLAENGE) {
        return undefined;
    }
    const enthalten = spielernamen.filter(name => name.toLowerCase().includes(suche));
    return enthalten.length === 1 ? enthalten[0] : undefined;
}
